import ExcludeTrialDropdown from './DataTableDropdowns/ExcludeTrialDropdown';
import EmailRecordDropdown from './DataTableDropdowns/EmailRecordDropdown';
import ConditionsDropDown from "./DataTableDropdowns/ConditionsDropdown";
import TriageDropdown from "./DataTableDropdowns/TriageDropdown";
import StudyContactsDropdown from "./DataTableDropdowns/StudyContactsDropdown";
import SpecialtyContactsDropdown from './DataTableDropdowns/SpecialtyContactsDropdown';
import StudyLocationsDropdown from "./DataTableDropdowns/StudyLocationsDropdown";
import CustomToolbar from "./TopToolbarComponents/CustomToolbar";

export default {
  tabs: {
    xpertTriage: {
      title: "Patient Triage",
      fetchKey: 'clinicalRegistry',
      responseKey: 'registry',
      fetchParam: 'Inbox',
      // customToolbar: CustomToolbar,
      paramOptions: {
        inbox: 'Inbox',
        piContacted: 'Study Team Contacted',
        patientContacted: 'Patient Contacted',
        final: 'Final',
        all: 'All',
        archived: 'Archived'
      },
      headers: ['patName', 'patEmail', 'mrn','senderN', 'platform','studyTitle', 'nct_link', 'status', 'dateRegistered','comments', 'primaryCrg', 'primaryMg'],
      route: '/user/overview/dtdata:_id',
      navRoute: '/trial_list/$instance/xpertTriage',
      routeState: {
        title: 'Patient Overview',
        auth: 'routeSettings:auth',
        instance: 'routeSettings:instance'
      }
    },
    triageSource: {
      title: "Entries by Source",
      fetchKey: 'triageSource',
      responseKey: 'registry',
      fetchParam: 'Source',
      headers: ['sendersName', 'sendersEmail','registryCount'],
      route: '/user/overview/dtdata:_id',
      navRoute: '/trial_list/$instance/triageSource',
      dropdown: TriageDropdown,
      routeState: {
        title: 'Entries by Studies',
        auth: 'routeSettings:auth',
        instance: 'routeSettings:instance'
      }
    },
    triageStudies: {
      title: "Entries by Studies",
      fetchKey: 'triageStudies',
      responseKey: 'registry',
      fetchParam: 'Studies',
      headers: ['nctNumber', 'studyTitle','registryCount'],
      route: '/user/overview/dtdata:_id',
      navRoute: '/trial_list/$instance/triageStudies',
      dropdown: TriageDropdown,
      routeState: {
        title: 'Entries by Studies',
        auth: 'routeSettings:auth',
        instance: 'routeSettings:instance'
      }
    },
    triagePatients: {
      title: "Entries by Patients",
      fetchKey: 'triagePatients',
      responseKey: 'registry',
      fetchParam: 'Patients',
      headers: ['nameNw', 'emailNw', 'registryCount'],
      route: '/user/overview/dtdata:_id',
      navRoute: '/trial_list/$instance/triagePatients',
      dropdown: TriageDropdown,
      routeState: {
        title: 'Entries by Patients',
        auth: 'routeSettings:auth',
        instance: 'routeSettings:instance'
      }
    },
    myPatients: {
      title: "My Patients",
      headers: ['patName', 'patEmail', 'studyTitle', 'dateRegistered'],
      fetchKey: 'clinicalRegistry',
      responseKey: 'registry',
      fetchParam: 'Inbox',
      paramOptions: {
        inbox: 'Inbox',
        piContacted: 'Study Team Contacted',
        patientContacted: 'Patient Contacted',
        final: 'Final',
        all: 'All',
        archived: 'Deleted',
      },
      route: '/user/overview/dtdata:_id',
      routeState: {
        title: 'Patient Overview',
        auth: 'routeSettings:auth',
        returnKey: true
      }
    },
    searchPatients: {
      title: "Email Broadcast",
      searchTable: true,
      headers: [
        'patEmail',
        'patName',
        'broadcastCount',
        'lastBroadcast',
        'conditions',
        'nct_link',
        'entryType',
        'status',
        'gender',
        'age',
        'mutationsIn',
        'mutationsOut',
        'pscore',
        'dateRegistered'
      ],
      modal: EmailRecordDropdown,
      navRoute: '/trial_list/$instance/searchPatients',
    },
    allTrials: {
      title: "Overview",
      headers: ['reviewed', 'qc_logs', 'approved', 'approvedLogs', 'priorityTrial', 'protocol', 'nct', 'oncology', 'briefTitle'],
      route: '/trials/overview/dtdata:concat',
      routeState: {
        auth: 'routeSettings:auth',
        instance: 'routeSettings:instance',
        title: 'Trial Overview',
        edit:false
      }
    },
    conditions: {
      title: "Conditions",
      headers: ['nct', 'briefTitle'],
      dropdown: ConditionsDropDown,
    },
    addTrials: {
      title: 'Add Trials'
    },
    surveyQuestions: {
      title: 'Survey Questions'
    },
    excludeTrials: {
      title: "Exclude Trials",
      headers: ['nctNumber', 'briefTitleFix', 'comments', 'isExcluded', 'dateExcluded'],
      dropdown: ExcludeTrialDropdown,
    },
    priorityTrials: {
      title: "Priority Trials",
      headers: ['priorityTrial', 'nct', 'briefTitle', 'removePriorityTrial'],
      addTrials: true
    },
    studyContacts: {
      title: "Study Contacts",
      fetchKey: 'nctContacts',
      headers: ['nct', 'protocol', 'title', 'contacts', 'pcrc', 'additional'],
      dropdown: StudyContactsDropdown
    },
    specialtyContacts: {
      title: "Specialty Contacts",
      fetchKey: 'specialtyContacts',
      headers: ['specialty', 'name', 'email', 'phone'],
      dropdown: SpecialtyContactsDropdown
    },
    getTrials: {
      title: "My Trials",
      headers: ['approved', 'nct', 'studyTitle', 'removePITrial'],
      fetchKey: 'getTrials',
      responseCellKey: 'nct',
      route: '/trials/overview/dtdata:_id',
      routeState: {
        auth: 'routeSettings:auth',
        returnKey: true
      }
    },
    emailRecords: {
      title: 'Broadcast Sent',
      headers: ['emailSender', 'emailSubject', 'emailMessage', 'emailRecipients', 'emailQuery', 'emailDate'],
      // dropdown: StudyContactsDropdown,
      responseKey: 'records',
      modal: EmailRecordDropdown,
    },
    studyLocation: {
      title: 'Study Location',
      headers: ['trialNct', 'trialLocation'],
      dropdown: StudyLocationsDropdown
    },
    bulkUploads: {
      title: 'Bulk Upload'
    },
    userManagement: {
      title: 'User Management'
    },
    userActivity: {
      title: 'User Activity'
    },
  },

  instances: {
    HFSA: {
      tabs: ['xpertTriage', 'searchPatients', 'allTrials','addTrials'] // removed customDescription
    },
    POPULACE: {
      tabs: ['xpertTriage','searchPatients', 'allTrials', 'addTrials', 'emailRecords'] // removed 'priorityTrials'
    },
    GVIEW: {
      tabs: ['allTrials', 'addTrials', 'studyContacts'] // removed customDescription , 'priorityTrials'
    },
    PI: {
      tabs: ['myPatients', 'getTrials']
    },
    default: {
      tabs: ['xpertTriage', 'triageStudies', 'triagePatients', 'triageSource', 'allTrials', 'studyContacts', 'specialtyContacts', 'addTrials', 'surveyQuestions', 'studyLocation', 'bulkUploads', 'userActivity' ] // removed searchPatients, emailRecords, customDescription, 'priorityTrials'
    },
  }
}
